export default __webpack_public_path__ + "static/media/avatar.8ff346e4.svg";